export default {
  products: 'name',
  salesman: 'salesman',
  outlets: 'createdAt',
  'outlet-revenue': 'createdAt',
  'payment-methods': 'createdAt',
  cashiers: 'cashier',
  registers: 'registerName',
  'total-revenues': 'createdAt',
  'sale-summary': 'createdAt',
  'sale-summary-by-payment': 'createdAt',
  'fulfillment-summary': 'createdAt',
  categories: 'productCategoryName',
  globalReport: 'createdAt'
}
